
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33688',
  depVersions: {
  "documents-public-ui": "static-1.33688",
  "client-types": "static-1.441",
  "documents-lib": "static-1.33693",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1801",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5276",
  "hs-test-utils": "static-1.7665",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11104",
  "I18n": "static-7.1537",
  "jasmine-immutable": "static-1.2699",
  "jasmine-runner": "static-1.6137",
  "lodash": "static-1.3",
  "quartz": "static-1.6561",
  "react": "static-7.175",
  "react-dlb": "static-1.69",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1-feature-id-1324-better-marker-tracking.14",
  "reporting-data": "static-1.65998",
  "reporting-testing-lib": "static-1.7932",
  "reporting-visualizations": "static-1.58075",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4430",
  "webpack-env": "static-1.54",
  "atom": "static-1.4757",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2146",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90907",
  "cssUtils": "static-1.693",
  "customer-data-filters-ui": "static-1.38475",
  "customer-data-objects": "static-1.7296",
  "customer-data-property-utils": "static-1.7753",
  "data-fetching-client": "static-1.9360",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4220",
  "flux-actions": "static-1.294",
  "FormsCommonComponents": "static-1.84945",
  "FormUrlGenerator": "static-2.4416",
  "foundations-components": "static-1.7271",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11412",
  "icons": "static-2.610",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6825",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3544",
  "property-translator": "static-1.5098",
  "quartz-config": "static-1.339",
  "quartz-core": "static-1.5780",
  "quick-fetch": "static-1.3622",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5070",
  "react-virtualized": "static-2.92",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7844",
  "reference-resolvers-lite": "static-1.7777",
  "report-customization-components": "static-1.12192",
  "reporting-enablement": "static-1.21690",
  "reporting-reports": "static-1.65677",
  "reporting-snowflake": "static-1.54617",
  "reporting-ui-components": "static-2.63271",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4289",
  "sales-content-partitioning": "static-1.8619",
  "SalesContentIndexUI": "static-3.8725",
  "sanitize": "static-1.4160",
  "sanitize-text": "static-1.7826",
  "self-service-api": "static-1.9910",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1453",
  "signup-constants": "static-1.18173",
  "signup-ui-lego-core": "static-1.20183",
  "signup-ui-url-generator": "static-2.7712",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.481",
  "superstore": "static-1.4455",
  "transmute": "static-2.77",
  "ui-addon-form-validation": "static-1.10681",
  "ui-addon-i18n": "static-1.10811",
  "ui-addon-react-router-dom": "static-1.9230",
  "ui-addon-upgrades": "static-9.17394",
  "ui-asset-management-lib": "static-1.10539",
  "ui-images": "static-2.1055",
  "UIComponents": "static-3.8051",
  "usage-tracker": "static-1.7020",
  "usage-tracker-container": "static-1.7010",
  "usage-tracker-core": "static-1.6870",
  "usage-tracker-public": "static-1.6831",
  "viral-links-lib": "static-1.6702",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3120",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2838",
  "quartz-webpack": "static-1.2785",
  "ai-components-ui-library": "static-1.8053",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4515",
  "foundations-theming": "static-1.4085",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4706",
  "foundations-theming-base": "static-1.3070",
  "HeadJS": "static-2.686",
  "framer-motion": "static-1.64",
  "hs-test-utils-bend-plugin": "static-1.2776",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4015",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7609",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3352",
  "persist-promise": "static-1.3370",
  "reporting-client-types": "static-1.2350",
  "hs-story-utils": "static-1.9113",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9179",
  "hubspotter-http": "static-1.4372",
  "sassPrefix": "static-1.149",
  "conversations-skeleton-state": "static-1.6936",
  "crm-message-bus": "static-1.42047",
  "customer-data-filters-ui-msw-helpers": "static-1.20909",
  "customer-data-objects-ui-components": "static-1.12687",
  "customer-data-reference-ui-components": "static-1.12819",
  "customer-data-ui-utilities": "static-1.9508",
  "framework-builder-read-service-client": "static-1.3740",
  "framework-data-schema-quick-fetch": "static-1.6455",
  "framework-data-schema-resolvers": "static-1.6550",
  "inbound-db-properties-service-client": "static-1.3571",
  "multi-account-reference-resolvers": "static-1.650",
  "onboarding-tours": "static-1.16108",
  "reporting-datasets-permissions-lib": "static-1.12667",
  "ui-addon-teams": "static-1.21067",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67248",
  "customer-data-properties": "static-1.50441",
  "forms-ai-lib": "static-1.3810",
  "forms-utils-lib": "static-1.11950",
  "foundations-components-test-utils": "static-1.4754",
  "react-dnd-compat": "static-1.4309",
  "react-tinymce": "static-1.54312",
  "tinymce-config": "static-2.53438",
  "ui-gdpr-components": "static-1.10031",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3540",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.951",
  "ui-fonts": "static-1.366",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.766",
  "mobile-manifest-mixins": "static-1.460",
  "quartz-auth": "static-1.236",
  "quartz-head": "static-1.226",
  "quartz-i18n": "static-1.236",
  "quartz-test": "static-1.236",
  "batch-promise": "static-1.1213",
  "external-options-client-types": "static-1.3876",
  "react-colorpicker": "static-2.9898",
  "reporting-insights-lib": "static-1.837",
  "copilot-toolkit": "static-1.10240",
  "data-quality-ui-library": "static-1.12063",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40393",
  "reporting-plugins": "static-1.9836",
  "ui-addon-draggable-compat": "static-2.3939",
  "ui-addon-opt": "static-4.8074",
  "ui-shepherd-react": "static-3.9826",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24401",
  "hubspot-apollo-client": "static-1.4565",
  "sales-templates-service-types-lib": "static-1.3887",
  "ui-business-units-lib": "static-1.8702",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "feature-store-service-types": "static-1.4213",
  "purchase-motions-components": "static-1.5311",
  "salesImages": "static-1.518",
  "ts-schema": "static-1.3798",
  "upgrade-management-service-types": "static-1.4204",
  "timezone-utils": "static-2.4930",
  "bender-build-tools": "static-1.2798",
  "chatspot-core": "static-1.19871",
  "bend-plugin-foundations-theming": "static-1.2568",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3515",
  "crm-pipelines-api-client-types": "static-1.3858",
  "multi-currency-client-types": "static-1.3415",
  "getting-started-shared-tasks": "static-1.17547",
  "growth-data-modal": "static-1.5015",
  "growth-onboarding-confetti": "static-1.2736",
  "growth-onboarding-next-action-utils": "static-1.1178",
  "navigation-components": "static-1.16930",
  "onboarding-tours-client": "static-1.4322",
  "onboarding-tours-utils": "static-1.174",
  "ui-shepherd-tracker": "static-1.7207",
  "ui-universal-auth": "static-1.8540",
  "user-context": "static-1.4774",
  "cms-field-types": "static-1.4489",
  "content-icons-ui": "static-1.2110",
  "integrations-lib": "static-1.15042",
  "calling-global-api": "static-1.63254",
  "calling-internal-common": "static-1.30975",
  "calling-lifecycle-internal": "static-1.64636",
  "calling-lifecycle-messages": "static-1.56930",
  "commerce-products-lib": "static-1.8499",
  "crm-links": "static-1.5934",
  "file-manager-components": "static-1.22550",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.334",
  "inbounddb-objects-service-types": "static-1.3943",
  "meetings-icalendar-utils-lib": "static-1.319",
  "object-builder-ui-client": "static-1.47607",
  "pipeline-validation-client-types": "static-1.3679",
  "property-value-citations": "static-1.1055",
  "pulse": "static-1.169",
  "smart-property-lib": "static-1.5465",
  "tiered-pricing": "static-1.644",
  "ui-addon-iframeable": "static-1.8698",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19264",
  "tinymce-themes": "static-1.55408",
  "data-token-picker": "static-1.15861",
  "hub-http-contrib": "static-1.2733",
  "interframe": "static-3.4474",
  "tinymce-data": "static-1.39523",
  "tinymce-plugins": "static-1.56552",
  "ui-addon-sales-email": "static-1.4899",
  "hubspotter-http-shared-msw-handlers": "static-1.9177",
  "magpie-lib": "static-1.5259",
  "magpie-types": "static-1.4719",
  "simple-logging-lib": "static-1.2736",
  "content-assistance-lib": "static-1.7281",
  "dashboard-lib": "static-1.80161",
  "ExportDialog": "static-6.10072",
  "hubspot-prosemirror": "static-1.17295",
  "hubspot-prosemirror-plugins": "static-1.17287",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8372",
  "campaign-roi-lib": "static-1.7928",
  "feedback-loader": "static-1.28651",
  "commerce-analytics-service-client": "static-1.3367",
  "onboarding-scopes": "static-1.6128",
  "apollo-link-hub-http": "static-2.4334",
  "hubspot-apollo-cache": "static-1.24",
  "growth-monetization-service-types": "static-1.4220",
  "nav-client-types": "static-1.2017",
  "purchase-motions-api": "static-1.5314",
  "trials-service-types": "static-1.3621",
  "chatspot-client-types": "static-1.10322",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.412",
  "getting-started-shared-tasks-store": "static-1.16665",
  "integrations-error-boundary-lib": "static-1.12457",
  "integrations-tracking-lib": "static-1.5269",
  "native-integrations-shared-strings": "static-1.7472",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10059",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.30981",
  "shared-worker-versioning": "static-1.10702",
  "calling-usage-tracker": "static-1.6224",
  "calling-orchestration-shared-library": "static-1.34452",
  "customer-data-tracking": "static-1.6546",
  "products-iframe-lib": "static-1.7042",
  "products-ui-components-shared-msw-handlers": "static-1.9561",
  "location-customization-utils-lib": "static-1.8191",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3842",
  "video-components-external": "static-1.10213",
  "video-data-lib": "static-1.33871",
  "directed-graph": "static-1.622",
  "event-emitter": "static-1.611",
  "breeze-intelligence-kit": "static-1.5148",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9262",
  "fsm": "static-1.3416",
  "policy-lib": "static-1.6487",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9325",
  "navigation-messaging": "static-1.6257",
  "FileManagerLib": "static-1.38190",
  "NamespacedHubStyle": "static-2.8795",
  "FileManagerCore": "static-1.38049",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11831",
  "layout-dnd-utils": "static-1.10806",
  "react-codemirror": "static-1.10288",
  "ui-addon-emoji-picker": "static-1.9575",
  "ui-brand-identity-lib": "static-1.13382",
  "ui-addon-video-player": "static-1.8406",
  "ui-coaching-tips": "static-1.27627",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8266",
  "payment-link-components": "static-1.22623",
  "EmailSignatureEditor": "static-1.23717",
  "eligibility-engine-service-types": "static-1.2902",
  "universal-page-editor-lib": "static-1.2682",
  "calling-orchestration-schema": "static-1.34677",
  "sales-views-client-types": "static-1.3978",
  "crm-record-cards-service-types": "static-1.3345",
  "content-media-composition-data-lib": "static-1.10959",
  "content-media-compositions": "static-2.14966",
  "media-bridge-lib": "static-1.18381",
  "trellis-story-utils": "static-1.4208",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5446",
  "FileManagerImages": "static-1.35701",
  "video-components": "static-1.12216",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4216",
  "video-embed": "static-1.34705",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67323",
  "layout-data-lib": "static-1.9131",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6271",
  "commerce-tours-lib": "static-1.5540",
  "growth-onboarding-reliability": "static-1.4773",
  "sales-checkout-service-client": "static-1.3379",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21102",
  "sales-email-signature-service-client": "static-1.3525",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21063",
  "outpost": "static-1.3900",
  "advanced-menus-core": "static-1.14630",
  "advanced-menus-lib": "static-1.11626",
  "ui-memberships-settings-lib": "static-1.33114",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14629",
  "simple-menus-lib": "static-1.16146"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33688",
  "client-types": "/client-types/static-1.441",
  "documents-lib": "/documents-lib/static-1.33693",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1801",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5276",
  "hs-test-utils": "/hs-test-utils/static-1.7665",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11104",
  "I18n": "/I18n/static-7.1537",
  "jasmine-immutable": "/jasmine-immutable/static-1.2699",
  "jasmine-runner": "/jasmine-runner/static-1.6137",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6561",
  "react": "/react/static-7.175",
  "react-dlb": "/react-dlb/static-1.69",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1324-better-marker-tracking.14",
  "reporting-data": "/reporting-data/static-1.65998",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.7932",
  "reporting-visualizations": "/reporting-visualizations/static-1.58075",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4430",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4757",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2146",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90907",
  "cssUtils": "/cssUtils/static-1.693",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38475",
  "customer-data-objects": "/customer-data-objects/static-1.7296",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7753",
  "data-fetching-client": "/data-fetching-client/static-1.9360",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4220",
  "flux-actions": "/flux-actions/static-1.294",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.84945",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4416",
  "foundations-components": "/foundations-components/static-1.7271",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11412",
  "icons": "/icons/static-2.610",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6825",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3544",
  "property-translator": "/property-translator/static-1.5098",
  "quartz-config": "/quartz-config/static-1.339",
  "quartz-core": "/quartz-core/static-1.5780",
  "quick-fetch": "/quick-fetch/static-1.3622",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5070",
  "react-virtualized": "/react-virtualized/static-2.92",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7844",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7777",
  "report-customization-components": "/report-customization-components/static-1.12192",
  "reporting-enablement": "/reporting-enablement/static-1.21690",
  "reporting-reports": "/reporting-reports/static-1.65677",
  "reporting-snowflake": "/reporting-snowflake/static-1.54617",
  "reporting-ui-components": "/reporting-ui-components/static-2.63271",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4289",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8619",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8725",
  "sanitize": "/sanitize/static-1.4160",
  "sanitize-text": "/sanitize-text/static-1.7826",
  "self-service-api": "/self-service-api/static-1.9910",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1453",
  "signup-constants": "/signup-constants/static-1.18173",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20183",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7712",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "superstore": "/superstore/static-1.4455",
  "transmute": "/transmute/static-2.77",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10681",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10811",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9230",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17394",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10539",
  "ui-images": "/ui-images/static-2.1055",
  "UIComponents": "/UIComponents/static-3.8051",
  "usage-tracker": "/usage-tracker/static-1.7020",
  "usage-tracker-container": "/usage-tracker-container/static-1.7010",
  "usage-tracker-core": "/usage-tracker-core/static-1.6870",
  "usage-tracker-public": "/usage-tracker-public/static-1.6831",
  "viral-links-lib": "/viral-links-lib/static-1.6702",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3120",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2838",
  "quartz-webpack": "/quartz-webpack/static-1.2785",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8053",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4515",
  "foundations-theming": "/foundations-theming/static-1.4085",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4706",
  "foundations-theming-base": "/foundations-theming-base/static-1.3070",
  "HeadJS": "/HeadJS/static-2.686",
  "framer-motion": "/framer-motion/static-1.64",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2776",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4015",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7609",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3352",
  "persist-promise": "/persist-promise/static-1.3370",
  "reporting-client-types": "/reporting-client-types/static-1.2350",
  "hs-story-utils": "/hs-story-utils/static-1.9113",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9179",
  "hubspotter-http": "/hubspotter-http/static-1.4372",
  "sassPrefix": "/sassPrefix/static-1.149",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6936",
  "crm-message-bus": "/crm-message-bus/static-1.42047",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20909",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12687",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12819",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9508",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3740",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6455",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6550",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3571",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.650",
  "onboarding-tours": "/onboarding-tours/static-1.16108",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12667",
  "ui-addon-teams": "/ui-addon-teams/static-1.21067",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67248",
  "customer-data-properties": "/customer-data-properties/static-1.50441",
  "forms-ai-lib": "/forms-ai-lib/static-1.3810",
  "forms-utils-lib": "/forms-utils-lib/static-1.11950",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4754",
  "react-dnd-compat": "/react-dnd-compat/static-1.4309",
  "react-tinymce": "/react-tinymce/static-1.54312",
  "tinymce-config": "/tinymce-config/static-2.53438",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10031",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3540",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.951",
  "ui-fonts": "/ui-fonts/static-1.366",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.766",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.460",
  "quartz-auth": "/quartz-auth/static-1.236",
  "quartz-head": "/quartz-head/static-1.226",
  "quartz-i18n": "/quartz-i18n/static-1.236",
  "quartz-test": "/quartz-test/static-1.236",
  "batch-promise": "/batch-promise/static-1.1213",
  "external-options-client-types": "/external-options-client-types/static-1.3876",
  "react-colorpicker": "/react-colorpicker/static-2.9898",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.837",
  "copilot-toolkit": "/copilot-toolkit/static-1.10240",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12063",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40393",
  "reporting-plugins": "/reporting-plugins/static-1.9836",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3939",
  "ui-addon-opt": "/ui-addon-opt/static-4.8074",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9826",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24401",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4565",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3887",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8702",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "feature-store-service-types": "/feature-store-service-types/static-1.4213",
  "purchase-motions-components": "/purchase-motions-components/static-1.5311",
  "salesImages": "/salesImages/static-1.518",
  "ts-schema": "/ts-schema/static-1.3798",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4204",
  "timezone-utils": "/timezone-utils/static-2.4930",
  "bender-build-tools": "/bender-build-tools/static-1.2798",
  "chatspot-core": "/chatspot-core/static-1.19871",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2568",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3515",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3858",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3415",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17547",
  "growth-data-modal": "/growth-data-modal/static-1.5015",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2736",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1178",
  "navigation-components": "/navigation-components/static-1.16930",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4322",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.174",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7207",
  "ui-universal-auth": "/ui-universal-auth/static-1.8540",
  "user-context": "/user-context/static-1.4774",
  "cms-field-types": "/cms-field-types/static-1.4489",
  "content-icons-ui": "/content-icons-ui/static-1.2110",
  "integrations-lib": "/integrations-lib/static-1.15042",
  "calling-global-api": "/calling-global-api/static-1.63254",
  "calling-internal-common": "/calling-internal-common/static-1.30975",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64636",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56930",
  "commerce-products-lib": "/commerce-products-lib/static-1.8499",
  "crm-links": "/crm-links/static-1.5934",
  "file-manager-components": "/file-manager-components/static-1.22550",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.334",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3943",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.319",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47607",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3679",
  "property-value-citations": "/property-value-citations/static-1.1055",
  "pulse": "/pulse/static-1.169",
  "smart-property-lib": "/smart-property-lib/static-1.5465",
  "tiered-pricing": "/tiered-pricing/static-1.644",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8698",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19264",
  "tinymce-themes": "/tinymce-themes/static-1.55408",
  "data-token-picker": "/data-token-picker/static-1.15861",
  "hub-http-contrib": "/hub-http-contrib/static-1.2733",
  "interframe": "/interframe/static-3.4474",
  "tinymce-data": "/tinymce-data/static-1.39523",
  "tinymce-plugins": "/tinymce-plugins/static-1.56552",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4899",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9177",
  "magpie-lib": "/magpie-lib/static-1.5259",
  "magpie-types": "/magpie-types/static-1.4719",
  "simple-logging-lib": "/simple-logging-lib/static-1.2736",
  "content-assistance-lib": "/content-assistance-lib/static-1.7281",
  "dashboard-lib": "/dashboard-lib/static-1.80161",
  "ExportDialog": "/ExportDialog/static-6.10072",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17295",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17287",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8372",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7928",
  "feedback-loader": "/feedback-loader/static-1.28651",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3367",
  "onboarding-scopes": "/onboarding-scopes/static-1.6128",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4334",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.24",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4220",
  "nav-client-types": "/nav-client-types/static-1.2017",
  "purchase-motions-api": "/purchase-motions-api/static-1.5314",
  "trials-service-types": "/trials-service-types/static-1.3621",
  "chatspot-client-types": "/chatspot-client-types/static-1.10322",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.412",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16665",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12457",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5269",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7472",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10059",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.30981",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10702",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6224",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34452",
  "customer-data-tracking": "/customer-data-tracking/static-1.6546",
  "products-iframe-lib": "/products-iframe-lib/static-1.7042",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9561",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8191",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3842",
  "video-components-external": "/video-components-external/static-1.10213",
  "video-data-lib": "/video-data-lib/static-1.33871",
  "directed-graph": "/directed-graph/static-1.622",
  "event-emitter": "/event-emitter/static-1.611",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5148",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9262",
  "fsm": "/fsm/static-1.3416",
  "policy-lib": "/policy-lib/static-1.6487",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9325",
  "navigation-messaging": "/navigation-messaging/static-1.6257",
  "FileManagerLib": "/FileManagerLib/static-1.38190",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8795",
  "FileManagerCore": "/FileManagerCore/static-1.38049",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11831",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10806",
  "react-codemirror": "/react-codemirror/static-1.10288",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9575",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13382",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8406",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27627",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8266",
  "payment-link-components": "/payment-link-components/static-1.22623",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23717",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2902",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2682",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34677",
  "sales-views-client-types": "/sales-views-client-types/static-1.3978",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3345",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10959",
  "content-media-compositions": "/content-media-compositions/static-2.14966",
  "media-bridge-lib": "/media-bridge-lib/static-1.18381",
  "trellis-story-utils": "/trellis-story-utils/static-1.4208",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5446",
  "FileManagerImages": "/FileManagerImages/static-1.35701",
  "video-components": "/video-components/static-1.12216",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4216",
  "video-embed": "/video-embed/static-1.34705",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67323",
  "layout-data-lib": "/layout-data-lib/static-1.9131",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6271",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5540",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4773",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3379",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21102",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3525",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21063",
  "outpost": "/outpost/static-1.3900",
  "advanced-menus-core": "/advanced-menus-core/static-1.14630",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11626",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33114",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14629",
  "simple-menus-lib": "/simple-menus-lib/static-1.16146"
}
};
